'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'lightbulb-on';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f672';
var svgPathData = 'M480 192c0 42.7-16.7 81.4-43.9 110.1-19.9 20.9-40.4 48.7-48.5 81.9l-135.2 0c-8.1-33.3-28.6-61-48.5-81.9-27.2-28.7-43.9-67.4-43.9-110.1 0-88.4 71.6-160 160-160s160 71.6 160 160zM256 416l128 0 0 16c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-16zm160-2.3C416 379.4 435.7 349 459.3 324.1 492 289.7 512 243.2 512 192 512 86 426 0 320 0S128 86 128 192c0 51.2 20 97.7 52.7 132.1 23.6 24.9 43.3 55.3 43.3 89.6l0 18.3c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-18.3zM304 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM40.9 18.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l48 32c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-48-32zm576 26.6c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-48 32c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l48-32zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zm560 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zM88.9 333.3c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-48 32c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l48-32zm480-26.6c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l48 32c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-48-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightbulbOn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;